import styled from "styled-components";
import { Device } from "../../../styles/screenSizes";
import { colors } from "../../../styles/variables";

export const StyledHeader = styled.header<{ isMenuOpen: boolean }>`
  z-index: 1;
  align-items: center;
  display: flex;
  font-size: 16px;
  height: 60px;
  justify-content: space-between;
  padding: 0 30px;
  width: 100%;
  background-color: ${({ theme }) =>
    theme.header?.portal?.backgroundColor || theme.color.primary};
  font-family: ${({ theme }) => theme.header?.fontFamily};
  position: relative;
  line-height: normal;

  ${({ theme }) =>
    theme.header?.portal?.fontWeight &&
    `font-weight: ${theme.header.portal.fontWeight};`}
  ${({ theme }) =>
    theme.header?.portal?.textTransform &&
    `text-transform: ${theme.header.portal.textTransform};`}
  ${({ theme }) =>
    theme.header?.portal?.fontSize &&
    `font-size: ${theme.header.portal.fontSize};`}
  ${({ theme }) =>
    theme.header?.portal?.borderBottomColor &&
    `border-bottom: 1px solid ${theme.header.portal.borderBottomColor};`}

  @media ${Device.notLaptop} {
    height: 60px;
    padding: 0 15px;
    ${({ isMenuOpen }) => isMenuOpen && `position: fixed; top: 0;`}
  }
`;

export const StyledNavLeft = styled.span`
  display: flex;
  align-items: center;

  > a {
    height: 50px;
  }

  @media ${Device.notLaptop} {
    /* center the logo https://stackoverflow.com/a/25776315 */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const StyledLogo = styled.img`
  height: 50px;
`;

export const StyledNavLink = styled.span<{ active?: boolean }>`
  color: ${({ theme }) => theme.header?.portal?.navLinkColor || colors.white};
  opacity: ${({ theme }) => theme.header?.portal?.navLinkOpacity || "0.8"};
  cursor: pointer;
  text-transform: ${({ theme }) => theme.header?.textTransform};
  text-decoration: ${(props) => props.active && "underline"};
  font-family: ${({ theme }) => theme.header?.fontFamily};
  font-weight: ${({ theme }) => theme.header?.fontWeight};

  &:hover {
    opacity: 1;
  }
`;

export const StyledNavLinksWrapper = styled.span`
  a {
    padding: 0 15px;
  }
  a:first-child {
    padding-left: 30px;
  }

  @media ${Device.notLaptop} {
    display: none;
  }
`;
